import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/register',
    component: (resolve) => require(['@/views/register'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: Layout,
    redirect: 'index',
  },
  // {
  //   path: '/404',
  //   component: (resolve) => require(['@/views/error/404'], resolve),
  //   hidden: true
  // },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/index'], resolve),
        name: 'Index',
        meta: { title: '首页', icon: 'sf_home', affix: true }
      },
      {
        path: 'recharge',
        hidden: true,
        component: (resolve) => require(['@/views/recharge'], resolve),
        name: 'Recharge',
        meta: { title: '充值', icon: 'sf_kyye' }
      },
      // {
      //   path: 'orderForm',
      //   hidden: true,
      //   component: (resolve) => require(['@/views/orderForm'], resolve),
      //   name: 'OrderForm',
      //   meta: { title: '发布工单', icon: 'sf_kyye' }
      // },
      // {
      //   path: 'orderForm/getOrder',
      //   hidden: true,
      //   component: (resolve) => require(['@/views/orderForm/getOrder/index'], resolve),
      //   name: 'GetOrder',
      //   meta: { title: '上门维修单', icon: '#' }
      // },
      // {
      //   path: 'orderForm/getOrder',
      //   hidden: true,
      //   component: (resolve) => require(['@/views/orderForm/getOrder/index'], resolve),
      //   name: 'GetOrder',
      //   meta: { title: '上门安装单', icon: '#' }
      // }
    ]
  },
  {
    path: '/orderForm',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: '/orderForm',
        component: (resolve) => require(['@/views/orderForm'], resolve),
        name: 'ReleaseOrder',
        meta: { title: '发布工单', icon: '#' }
      },
      {
        path: 'getRepairOrder',
        component: (resolve) => require(['@/views/orderForm/getRepairOrder/index'], resolve),
        name: 'GetRepairOrder',
        meta: { title: '上门维修单', icon: '#' }
      },
      {
        path: 'getInstallOrder',
        component: (resolve) => require(['@/views/orderForm/getInstallOrder/index'], resolve),
        name: 'GetInstallOrder',
        meta: { title: '上门安装单', icon: '#' }
      },
      {
        path: 'getMaintainOrder',
        component: (resolve) => require(['@/views/orderForm/getMaintainOrder/index'], resolve),
        name: 'GetMaintainOrder',
        meta: { title: '清洗保养单', icon: '#' }
      },
      {
        path: 'getSxOrder',
        component: (resolve) => require(['@/views/orderForm/getSxOrder/index'], resolve),
        name: 'GetSxOrder',
        meta: { title: '上门测量单', icon: '#' }
      },
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: (resolve) => require(['@/views/system/user/profile/index'], resolve),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      },
    ]
  },
  {
    path: '/system/user-auth',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'role/:userId(\\d+)',
        component: (resolve) => require(['@/views/system/user/authRole'], resolve),
        name: 'AuthRole',
        meta: { title: '分配角色', activeMenu: '/system/user'}
      }
    ]
  },
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'user/:roleId(\\d+)',
        component: (resolve) => require(['@/views/system/role/authUser'], resolve),
        name: 'AuthUser',
        meta: { title: '分配用户', activeMenu: '/system/role'}
      }
    ]
  },
  {
    path: '/system/dict-data',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index/:dictId(\\d+)',
        component: (resolve) => require(['@/views/system/dict/data'], resolve),
        name: 'Data',
        meta: { title: '字典数据', activeMenu: '/system/dict'}
      }
    ]
  },
  {
    path: '/monitor/job-log',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/monitor/job/log'], resolve),
        name: 'JobLog',
        meta: { title: '调度日志', activeMenu: '/monitor/job'}
      }
    ]
  },
]

let opts = {
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
}

if (process.env.NODE_ENV === 'production') {
  opts['base'] = '/djyweb/'
}

export default new Router(opts)
